module.exports = __webpack_public_path__ + "img/klinks.3ab82159.jpg";